import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth, homeForRole } from "@/lib/auth";
import { AppShell } from "@/components/AppShell";
import { Loading } from "@/components/brand";

export function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loading /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeForRole(user.role)} replace />;
  return <AppShell>{children}</AppShell>;
}

// Full-screen protected route without the app shell (e.g. Live room).
export function BareProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loading /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
